import * as React from 'react';
import styled from 'styled-components';
import { FlexCol, FlexRow } from '../../Defaults/Flexbox/Flexbox';
import { rem } from 'polished';
import { OutsideClick } from '../../Defaults/OutsideClick';
import { MiniCartItem } from './MiniCartItem';
import { __ } from 'react-i18n/lib';
import { prop, getSymbolFromCurrency } from '../../../utilities';
import {
  getProductDefaultInfo,
  getCartSummaryInfo,
} from '../../../utilities/selectors';
import { FreeDeliveryBox } from '../Cart/Summary/FreeDeliveryBox';
import { ZlataPriadkaButtonSecondary as ButtonSecondary } from '../../..';

const Wrapper = styled(FlexCol)`
  background: ${({ theme }) => theme.color.white};
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(14)};
  line-height: ${rem(21)};
  font-weight: 300;
  padding: ${rem(24)};
  width: ${rem(400)};
  border-radius: ${rem(4)};
  box-shadow: 0 ${rem(2)} ${rem(32)} #00000029;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const EmptyCart = styled.div``;

const TotalPrice = styled(FlexRow)`
  justify-content: space-between;
  font-size: ${rem(14)};
  line-height: ${rem(14)};
  margin-bottom: ${rem(24)};
  align-items: baseline;
  border-top: ${rem(2)} solid #eeeeee;
  padding-top: ${rem(24)};
`;

const Price = styled.div`
  font-weight: 500;
  font-size: ${rem(20)};
  line-height: ${rem(24)};
`;

const StyledButton = styled(ButtonSecondary)`
  font-weight: 600;
  background: ${({ theme }) => theme.colors.secondary};
`;

const Scrollable = styled.div`
  max-height: ${rem(180)};
  padding: 0 ${rem(8)};
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: ${rem(2)};
    border-radius: 2px;
  }
  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.sliderRailColor};
  }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.secondary};
  }
`;
interface Props {
  cartData: any;
  handleToCartButtonClick: any;
  freeDel: number | null;
  addToCart: any;
}

class MiniCart extends React.Component<Props> {
  public render() {
    const {
      cartData,
      handleToCartButtonClick,
      freeDel,
      addToCart,
    } = this.props;
    const { totalPrice, currency } = getCartSummaryInfo(cartData);
    const { items } = cartData || [];

    let percentage = 0;
    if (freeDel) {
      percentage = (+totalPrice * 100) / (freeDel + Number(totalPrice));

      if (percentage > 100) {
        percentage = 100;
      }
    }

    return (
      <Wrapper>
        {items && items.length > 0 ? (
          <>
            <Scrollable>
              {items.map((item: any, i) => {
                return (
                  <MiniCartItem item={item} key={i} addToCart={addToCart} />
                );
              })}
            </Scrollable>
            <FreeDeliveryBox
              currency={currency}
              value={freeDel}
              percentage={percentage}
            />
            <TotalPrice>
              {__('Celkom k úhrade s DPH')}
              <Price>
                {totalPrice || 0} {getSymbolFromCurrency(currency)}
              </Price>
            </TotalPrice>
            <StyledButton onClick={handleToCartButtonClick}>
              {__('Prejsť do košíka')}
            </StyledButton>
          </>
        ) : (
          <EmptyCart>{__('Váš nákupný košík je prázdny')}</EmptyCart>
        )}
      </Wrapper>
    );
  }
}

export { MiniCart };
